import { render, staticRenderFns } from "./terms-and-conditions.component.vue?vue&type=template&id=c858cd22&scoped=true&"
import script from "./terms-and-conditions.component.vue?vue&type=script&lang=ts&"
export * from "./terms-and-conditions.component.vue?vue&type=script&lang=ts&"
import style0 from "./terms-and-conditions.component.vue?vue&type=style&index=0&id=c858cd22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c858cd22",
  null
  
)

export default component.exports